// extracted by mini-css-extract-plugin
export default {"no_webgl":"DataViewer_no_webgl__PpuOQ","back":"DataViewer_back__skV4I","viewer":"DataViewer_viewer__qfQOb"};